<script lang="ts" setup>
import { useUser } from '@/modules/IdentityAndAccess/useUser'
import { useProfileImage } from '@/modules/WorkspaceSettings/useProfileImage'
import { useIntercom } from '@/sharedComposables/useIntercom'
import AvatarIcon from '@/uiKit/AvatarIcon.vue'
import DarwinButton from '@/uiKit/DarwinButton.vue'
import DividerLine from '@/uiKit/DividerLine.vue'
import IconSprite from '@/uiKit/IconSprite.vue'

const { showIntercom } = useIntercom()
const { user } = useUser()

const profileImageUrl = useProfileImage(user?.id ?? '')
</script>

<template>
  <div class="flex flex-col gap-4 p-2 pt-4">
    <div
      class="flex h-[180px] flex-col rounded-corner-8"
      :style="{
        background: 'var(--gray-900)',
      }"
      data-theme="dark"
    >
      <div class="flex w-full items-end justify-center p-4 pb-0">
        <div>
          <AvatarIcon
            class="size-8 rounded-full"
            shape="circle"
            :full-text="`${user?.firstName} ${user?.lastName}`"
            :url="profileImageUrl"
          />
        </div>
        <div class="pb-2.5">
          <img
            class="size-8 rounded-full"
            srcset="
              @/assets/images/person_1@1x.png,
              @/assets/images/person_1@2x.png 2x,
              @/assets/images/person_1@3x.png 3x
            "
            src="@/assets/images/alberto@3x.png"
            alt="Person 1 avatar"
          />
        </div>
        <div>
          <img
            class="size-8 rounded-full"
            srcset="
              @/assets/images/person_2@1x.png,
              @/assets/images/person_2@2x.png 2x,
              @/assets/images/person_2@3x.png 3x
            "
            src="@/assets/images/alberto@3x.png"
            alt="Person 2 avatar"
          />
        </div>
      </div>
      <div class="flex h-full flex-col items-center justify-center p-4 pt-3">
        <p class="text-lg-15px-bold text-text">Chat with us via Intercom</p>
        <div class="flex items-center gap-1">
          <div class="flex size-3 items-center justify-center">
            <div class="relative size-1.5 rounded-full bg-icon-success shadow-focus-ring-success" />
          </div>
          <p class="text-sm-12px-light text-text-subtle">Available now</p>
        </div>
      </div>
      <DividerLine
        color="subtle"
        :width="1"
      />
      <div class="flex flex-col items-center gap-1 p-1">
        <DarwinButton
          variant="transparent-link"
          size="md"
          class="w-full"
          @click="showIntercom"
        >
          Launch conversation
          <template #trailing-icon>
            <IconSprite icon="chevron-right" />
          </template>
        </DarwinButton>
      </div>
    </div>
  </div>
</template>
